import { inject, Injectable } from '@angular/core';
import { FuncService } from '../../services';

@Injectable({ providedIn: 'root' })
export class FinanceAreaService {

	private func = inject(FuncService);
	// public readonly experienceData = signal<ExperienceFuncData | undefined>(undefined);


	// public async reloadData() {
	// 	const trimesterId = this.trimesterService.selectedTrimester()?.trimesterId;
	// 	//Should never happen, but just in case.
	// 	//This is a safety check to ensure that the experience data is only loaded when a trimester is selected.
	// 	//If no trimester is selected, the experience data will not be loaded
	// 	//and the service will not be able to provide any data.
	// 	if (trimesterId) {
	// 		const data = await this.func.experience.getData({ trimesterId });
	// 		this.experienceData.set(data);
	// 	}
	// }

	// public async loadExperienceData() {
	// 	if (!this.experienceData()) await this.reloadData();
	// }

}